import { env } from '@toggle/helpers';

interface RuntimeValueOptions {
  runtimeValue?: string;
  buildValue?: string;
  defaultValue?: string;
}

interface RuntimeNumberOptions extends RuntimeValueOptions {
  name: string;
  defaultValue: string;
}

export const resolveValue = ({
  runtimeValue,
  buildValue,
  defaultValue = '',
}: RuntimeValueOptions) => env(runtimeValue, env(buildValue, defaultValue));

export const parseFeatureFlags = (value: string) =>
  value
    .split(',')
    .map(flag => flag.trim())
    .filter(Boolean);

export const parseFiniteNumber = ({
  name,
  runtimeValue,
  buildValue,
  defaultValue,
}: RuntimeNumberOptions) => {
  const value = resolveValue({ runtimeValue, buildValue, defaultValue });
  const parsedValue = Number(value);

  if (!Number.isFinite(parsedValue)) {
    throw new Error(`${name} must be a finite number`);
  }

  return parsedValue;
};

export const parseOptionalBoolean = (
  name: string,
  value?: boolean | string
): boolean | undefined => {
  if (value === undefined || value === '') {
    return undefined;
  }

  if (value === true || value === 'true') {
    return true;
  }

  if (value === false || value === 'false') {
    return false;
  }

  throw new Error(`${name} must be "true" or "false"`);
};
